import React from 'react';
import { Button } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from "../../../i18next";

const SearchButton = props => {

    const { button, topPosition, botPosition } = styles;

    const renderButtonIcon = (search, hideIcon) => {
        if (hideIcon) {
            return <span style={{fontWeight: 'bold'}}>+</span>;
        }
        return <MaterialIcon icon={search ? "search" : "room"} size={15} color="white" />
    }

    return (
        <Button onClick={props.onClick} color="primary" style={props.positionTop ? { ...button, ...topPosition } : { ...button, ...botPosition }} >{renderButtonIcon(props.search, props.plusIcon)} &nbsp; {props.text === 'Search' ? i18n.t('screens:customerInsightScreen.search') : props.text}</Button>
    );
}

SearchButton.defaultProps = {
    search: true,
    text: 'Search',
    positionTop: true,
    plusIcon: false
}

export default SearchButton;

const styles = {
    button: {
        borderRadius: '15px',
        height: '20px',
        padding: '0 10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '13px'
    },
    topPosition: {
        margin: "8px 8px 0 0"
    },
    botPosition: {
        margin: "2px 0 8px 0"
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/SearchButton.js